import { API_URL } from '@/constants/config';

const base = API_URL + '/v3.5';

/**
 * Article Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const configService = (http, cookies) => ({
  /**
   * Get Metadata Config
   */
  async getMetadataConfig() {
    const { data } = await http.$get(`${base}/metadata/config/web`, {
      cache: {
        excludeFromCache: false,
        key: () => 'Config',
        maxAge: 5 * 60 * 1000,
      },
    });
    return { data };
  },
});
